module.exports = __webpack_public_path__ + "static/media/ab-shape-1.2390efe6.png";